import logo from './eci-logo.png';

export default function ECILogo() {
  return <img src={logo} alt="" width={50} />;
}
